import { environment } from "./util.environment.js";
import { makeConfigRef } from "../util.make-config-ref.js";
//#region src/env/util.make-environment-ref.ts
/**
* tiny wrapper on top of makeConfigRef for usage with environment variable
* utilities, that will auto-observe changes in the applied environment and
* ensure that up-to-date values are returned
*/
function makeEnvironmentRef(getter) {
	const configRef = makeConfigRef(getter);
	environment.observe(() => {
		configRef.__update(getter);
	});
	return configRef;
}
//#endregion
export { makeEnvironmentRef };

//# sourceMappingURL=util.make-environment-ref.js.map